<template>
  <ion-page>
    <ion-header class="ion-no-border">
      <ion-toolbar>
        <ion-buttons slot="start">
          <back-button
            :defaultHref="{ name: 'home' }"
            :icon="require('@lib/assets/icons/icon_zurueck.svg')"
            text=""
          >
          </back-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content ref="content" :fullscreen="true">
      <ion-grid fixed class="ion-padding">
        <ion-row>
          <ion-col>
            <div
              class="c-header u-bg-orange"
              :style="{
                'background-image':
                  'url(' +
                  require('@/assets/img/content/icon_roodie_call.svg') +
                  ')',
              }"
            ></div>
            <!-- <p>
              <b>Wie funktioniert ein Arztgespräch per Video oder Telefon?</b>
            </p> -->
            <p>
              <ion-row>
                <ion-col size="auto">
                  <ion-icon
                    size="large"
                    :src="require('@lib/assets/icons/icon_telefon.svg')"
                  />
                </ion-col>
                <ion-col>
                  &nbsp;<b>1.</b> Wählen Sie die Zahnärztliche Tagesklinik in
                  Ihrer Nähe.</ion-col
                >
              </ion-row>
            </p>
            <p>
              <ion-row>
                <ion-col size="auto">
                  <ion-icon
                    size="large"
                    :src="
                      require('@lib/assets/icons/icon_verlaufskontrolle.svg')
                    "
                  />
                </ion-col>
                <ion-col>
                  &nbsp;<b>2.</b> Sie haben die Wahl:<br />
                  - Buchen Sie schnell und bequem gleich online einen Termin.
                  Sie erhalten gleich eine Terminbestätigung per Mail und wir
                  schicken Ihnen 24 Stunden vor Ihrem Zahnarzt-Termin noch eine
                  kleine Erinnerung.<br />
                  - Oder wählen Sie „Termin anfragen“ und geben Sie einfach jene
                  Tage und Zeifenster an, die für Sie nicht möglich sind. Das
                  Team der Zahnärztlichen Tageskliniken kontaktiert Sie
                  umgehend, um einen Termin mit Ihnen zu vereinbaren.
                </ion-col>
              </ion-row>
            </p>
            <p>
              <ion-row>
                <ion-col size="auto">
                  <ion-icon
                    size="large"
                    :src="require('@lib/assets/icons/icon_erstdiagnose.svg')"
                  />
                </ion-col>

                <ion-col>
                  &nbsp;<b>3.</b> Teilen Sie Ihren Roodie.Check mit den Experten
                  der Zahnärztlichen Tageskliniken, damit sie diese auf den
                  Termin mit Ihnen gut vorbereiten können.
                </ion-col>
              </ion-row>
            </p>
            <!-- <ion-icon :src="require('@lib/assets/icons/info.svg')" />
            <ion-text color="primary"
              >&nbsp;<b>Hinweis:</b>
              <p>
                Eine Fernbehandlung kann einen persönlichen Arztbesuch nicht
                ersetzen, ist aber eine sehr gute Ergänzung - gerade, wenn es um
                eine rasche Erstabklärung geht.
              </p>
            </ion-text> -->
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-content>
  </ion-page>
</template>

<script>
import { chevronBack } from "ionicons/icons";
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonContent,
  IonButton,
  IonGrid,
  IonRow,
  IonCol,
  IonIcon,
  IonButtons,
  IonBackButton,
  //   IonText,
} from "@ionic/vue";

export default {
  components: {
    IonPage,
    IonHeader,
    IonToolbar,
    IonContent,
    IonButton,
    IonGrid,
    IonRow,
    IonCol,
    IonIcon,
    IonButtons,
    IonBackButton,
    // IonText,
  },
  data() {
    return {};
  },
  setup() {
    return {
      chevronBack,
    };
  },
};
</script>

<style lang="scss" scoped></style>
